var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "about-project", on: { mousemove: _vm.shakeIt } },
    [
      _c(
        "div",
        { staticClass: "about-project__wrapper" },
        [
          _c("MainPageAnimation"),
          _c("div", { staticClass: "about-project__container" }, [
            _c(
              "div",
              { staticClass: "about-project__content" },
              [
                _c("BaseTitle", {
                  staticClass: "about-project__title",
                  attrs: { text: _vm.titleText, tag: "h2" }
                }),
                _c("BaseCaption", {
                  staticClass: "about-project__caption",
                  attrs: { text: _vm.captionCaption }
                }),
                _c("BaseText", {
                  staticClass: "about-project__descr",
                  attrs: { text: _vm.descriptionText }
                })
              ],
              1
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32cf8cd6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32cf8cd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/AboutProjectBlock.vue
// module id = 1rJQ
// module chunks = 2